import { render, staticRenderFns } from "./MinesStatisticsTable.vue?vue&type=template&id=7fdecff0&scoped=true&"
import script from "./MinesStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./MinesStatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./MinesStatisticsTable.vue?vue&type=style&index=0&id=7fdecff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdecff0",
  null
  
)

export default component.exports